var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visitor-attributes" },
    _vm._l(_vm.getAttributes(), function (attribute) {
      return _c("div", { staticClass: "attribute w-full" }, [
        _c(
          "span",
          {
            staticClass: "material-icons",
            staticStyle: { "font-size": "15px" },
          },
          [_vm._v(_vm._s(attribute.icon))]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "name" }, [_vm._v(_vm._s(attribute.label))]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "value w-full",
            class: { empty: !_vm.visitor[attribute.name] },
          },
          [
            attribute.type === "json"
              ? _c(
                  "div",
                  [
                    _c(
                      "button",
                      {
                        staticClass: "classic-button visitor-attr",
                        on: {
                          click: function ($event) {
                            _vm.JSONModal = true
                          },
                        },
                      },
                      [_vm._v("JSON PREVIEW")]
                    ),
                    _vm._v(" "),
                    _vm.JSONModal
                      ? _c(
                          "Modal2",
                          {
                            attrs: {
                              title: attribute.label,
                              "show-footer": false,
                            },
                            on: {
                              cancel: function ($event) {
                                _vm.JSONModal = false
                              },
                            },
                          },
                          [
                            _c("prism-editor", {
                              staticClass: "my-editor",
                              attrs: {
                                value: _vm.jsonFormat(
                                  _vm.getData(_vm.visitor, attribute)
                                ),
                                "line-numbers": false,
                                highlight: _vm.highlighter,
                                readonly: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c("SupsisButton", [_vm._v(" COPY JSON ")]),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  {
                                    on: {
                                      click: function ($event) {
                                        _vm.JSONModal = false
                                      },
                                    },
                                  },
                                  [_vm._v(" CANCEL ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    class: {
                      "editable-input": _vm.isContentEditable(attribute),
                    },
                  },
                  [
                    _vm.isContentEditable(attribute) &&
                    attribute.name == _vm.editingProperty
                      ? _c(
                          "div",
                          { staticClass: "edited-input" },
                          [
                            _c("a-input", {
                              staticClass: "w-full",
                              on: {
                                mouseleave: function ($event) {
                                  _vm.editingProperty = null
                                },
                                change: function ($event) {
                                  return _vm.changeAttr(
                                    attribute,
                                    $event.target.value
                                  )
                                },
                              },
                              model: {
                                value: _vm.editingContent,
                                callback: function ($$v) {
                                  _vm.editingContent = $$v
                                },
                                expression: "editingContent",
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                },
                                expression:
                                  "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                              },
                            ],
                            staticClass: "edited-input",
                            attrs: {
                              content:
                                _vm.getData(_vm.visitor, attribute) || "N/A",
                            },
                            on: {
                              mouseover: function ($event) {
                                _vm.editingProperty = attribute.name
                                _vm.editingContent =
                                  _vm.getData(_vm.visitor, attribute) == "N/A"
                                    ? ""
                                    : _vm.getData(_vm.visitor, attribute)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.getData(_vm.visitor, attribute) || "N/A"
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                    _vm._v(" "),
                    _vm.isContentEditable(attribute)
                      ? _c("span", { staticClass: "material-icons mr-1" }, [
                          _vm._v("edit"),
                        ])
                      : _vm._e(),
                  ]
                ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }